import { initLocale } from "./common.init";

export const initAuctionAuthor = (author = {}) => ({
    ...(author || {}),

    name: initLocale(author?.name),
    country: initLocale(author?.country),

    content: author?.content ?? null,

    bornAt: author?.bornAt ?? null,
    diedAt: author?.diedAt ?? null,

    index: author?.index ?? null,
    isHidden: author?.isHidden ?? false,
});
